/* Akoviya ClearDrive page (akoviya-cv-* sections): gallery, pack cards, countdown, quotes, reviews, sticky bar. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var once = function (el, key) { if (el['_cv' + key]) return false; el['_cv' + key] = true; return true; };
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- gallery ---------- */
  function initGallery(g) {
    if (!once(g, 'gal')) return;
    var track = $('[data-cv-gal-track]', g);
    if (!track) return;
    var slides = $$('.cv-gal__slide', track);
    var thumbs = $$('.cv-gal__thumb', g);
    var dots = $$('[data-cv-gal-dots] span', g);
    var cur = 0;
    function mark(i) {
      cur = i;
      thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); });
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
      var row = thumbs[i] && thumbs[i].parentNode;
      if (row && row.scrollWidth > row.clientWidth) {
        row.scrollTo({ left: thumbs[i].offsetLeft - row.offsetLeft - (row.clientWidth - thumbs[i].offsetWidth) / 2, behavior: 'smooth' });
      }
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      mark(i);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    $$('[data-cv-gal-step]', g).forEach(function (b) {
      b.addEventListener('click', function () { go(cur + Number(b.getAttribute('data-cv-gal-step'))); });
    });
    var tid;
    track.addEventListener('scroll', function () {
      clearTimeout(tid);
      tid = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== cur && slides[i]) mark(i);
      }, 60);
    }, { passive: true });
  }

  /* ---------- pack cards + add to cart ---------- */
  function initProduct(root) {
    if (!once(root, 'prod')) return;
    var cards = $$('[data-cv-pack]', root);
    var input = $('[data-cv-variant-input]', root);
    var atc = $('[data-cv-atc]', root);
    function pick(card, silent) {
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var vid = card.getAttribute('data-variant');
      var avail = card.getAttribute('data-available') === 'true';
      if (input && vid) {
        input.value = vid;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (atc) {
        var lab = $('[data-cv-atc-label]', atc);
        var txt = avail ? atc.getAttribute('data-label') : atc.getAttribute('data-soldout');
        if (lab) {
          lab.textContent = txt;
          if (avail && atc.getAttribute('data-show-price') === 'true') {
            var sep = document.createElement('span');
            sep.className = 'cv-btn__sep';
            sep.textContent = '|';
            lab.appendChild(sep);
            lab.appendChild(document.createTextNode(card.getAttribute('data-price')));
          }
        }
        atc.disabled = !avail;
      }
      if (!silent && vid && window.history && history.replaceState) {
        try {
          var u = new URL(location.href);
          u.searchParams.set('variant', vid);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* ignore */ }
      }
      $$('[data-cv-prepaid-price]', root).forEach(function (el) { if (card.getAttribute('data-prepaid')) el.textContent = card.getAttribute('data-prepaid'); });
      $$('[data-cv-prepaid-pack]', root).forEach(function (el) { el.textContent = card.getAttribute('data-title') || ''; });
      document.dispatchEvent(new CustomEvent('cv:pack', { detail: {
        title: card.getAttribute('data-title'), price: card.getAttribute('data-price'),
        was: card.getAttribute('data-was'), variant: vid, available: avail
      } }));
    }
    cards.forEach(function (c) {
      c.addEventListener('click', function () { pick(c); });
      c.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(c); }
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var i = cards.indexOf(c) + (e.key === 'ArrowRight' ? 1 : -1);
          var n = cards[(i + cards.length) % cards.length];
          n.focus(); pick(n);
        }
      });
    });
    var start = cards.filter(function (c) { return c.classList.contains('is-on'); })[0] || cards[0];
    if (start) pick(start, true);
  }

  /* ---------- countdown (real end date, never restarts) ---------- */
  function initCountdown(el) {
    if (!once(el, 'cd')) return;
    var end = Date.parse(el.getAttribute('data-end'));
    var out = $('[data-cv-cd-t]', el);
    var days = el.getAttribute('data-days') === 'true';
    var u = ($('[data-u]', el) || { getAttribute: function () { return 'd|h|m|s'; } }).getAttribute('data-u').split('|');
    if (!end || !out) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) {
        if (!designMode) { el.hidden = true; el.style.display = 'none'; }
        clearInterval(t);
        s = 0;
      }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      if (!days) h += d * 24;
      var parts = days ? [[d, u[0]], [h, u[1]], [m, u[2]], [sec, u[3]]] : [[h, u[1]], [m, u[2]], [sec, u[3]]];
      out.innerHTML = parts.map(function (p) { return '<span>' + pad(p[0]) + p[1] + '</span>'; }).join('');
    }
    var t = setInterval(tick, 1000);
    tick();
  }

  /* ---------- quotes slider ---------- */
  function initQuotes(sec) {
    if (!once(sec, 'q')) return;
    var slides = $$('[data-cv-q-slide]', sec);
    var dots = $$('[data-cv-q-dots] button', sec);
    if (slides.length < 2) return;
    var cur = 0, timer;
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-on', j === cur); });
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === cur); });
    }
    function auto() {
      clearInterval(timer);
      if (sec.getAttribute('data-auto') === 'true') timer = setInterval(function () { go(cur + 1); }, 5000);
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); auto(); }); });
    var x0 = null;
    sec.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    sec.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(cur + (dx < 0 ? 1 : -1)); auto(); }
      x0 = null;
    });
    auto();
  }

  /* ---------- reviews ---------- */
  function setRating(count, avg) {
    $$('[data-cv-rating]').forEach(function (r) {
      var txt = $('[data-cv-rating-text]', r);
      var fg = $('.cv-stars__fg', r);
      if (count > 0) {
        if (txt) txt.textContent = (r.getAttribute('data-tpl') || '').replace('[count]', count).replace('[rating]', avg);
        if (fg) fg.parentNode.style.setProperty('--cv-st-p', Math.round(avg / 5 * 100) + '%');
        r.hidden = false;
      } else if (!designMode) {
        var empty = r.getAttribute('data-empty') || '';
        if (r.hasAttribute('data-empty-ph') || !empty) { r.hidden = true; }
        else { if (txt) txt.textContent = empty; r.hidden = false; }
      }
    });
  }
  function initReviews(sec) {
    if (!once(sec, 'rv')) return;
    var list = $('[data-cv-rv-list]', sec);
    // pull in the "Continue the list above" sections that follow this one
    $$('[data-cv-rv-cont]').forEach(function (c) {
      if (!(sec.compareDocumentPosition(c) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
      $$('[data-cv-rv]', c).forEach(function (it) { list.appendChild(it); });
    });
    var items = $$('[data-cv-rv]', list);
    var real = items.filter(function (it) { return it.getAttribute('data-sample') !== 'true'; });
    var count = real.length;
    var sum = real.reduce(function (a, it) { return a + Number(it.getAttribute('data-rating') || 0); }, 0);
    var avg = count ? Math.round(sum / count * 10) / 10 : 0;
    var avgEl = $('[data-cv-rv-avg]', sec);
    if (avgEl) avgEl.textContent = avg;
    var sumStars = avgEl && avgEl.parentNode.querySelector('.cv-stars');
    if (sumStars) sumStars.style.setProperty('--cv-st-p', Math.round(avg / 5 * 100) + '%');
    var n = $('[data-cv-rv-n]', sec);
    if (n) n.textContent = (n.getAttribute('data-tpl') || '').replace('[count]', count);
    $$('[data-cv-rv-bar]', sec).forEach(function (b) {
      var st = Number(b.getAttribute('data-cv-rv-bar'));
      var c = real.filter(function (it) { return Number(it.getAttribute('data-rating')) === st; }).length;
      var em = $('em', b); if (em) em.style.width = (count ? Math.round(c / count * 100) : 0) + '%';
      var nn = $('[data-n]', b); if (nn) nn.textContent = c;
    });
    if (count > 0 || designMode || sec.getAttribute('data-show-empty') === 'true') sec.hidden = false;
    var emptyBox = $('[data-cv-rv-empty]', sec);
    if (emptyBox) emptyBox.hidden = count > 0 || designMode;
    $$('[data-cv-rv-full]', sec).forEach(function (el) { el.hidden = count === 0 && !designMode; });
    setRating(count, avg);

    var step = Number(sec.getAttribute('data-step')) || 6;
    var shown = step, filter = 'all';
    var more = $('[data-cv-rv-more]', sec);
    function match(it) {
      if (filter === 'photo') return it.getAttribute('data-photo') === 'true';
      if (filter !== 'all') return it.getAttribute('data-rating') === filter;
      return true;
    }
    function render() {
      var vis = 0, total = 0;
      items.forEach(function (it) {
        var ok = match(it);
        if (ok) total++;
        var show = ok && vis < shown;
        if (show) vis++;
        it.classList.toggle('is-hide', !show);
      });
      if (more) more.hidden = total <= shown;
    }
    if (more) more.addEventListener('click', function () { shown += step; render(); });
    $$('[data-cv-rv-filters] button', sec).forEach(function (b, i, all) {
      b.addEventListener('click', function () {
        all.forEach(function (x) { x.classList.toggle('is-on', x === b); });
        filter = b.getAttribute('data-f'); shown = step; render();
      });
    });
    render();

    var box = $('[data-cv-zoom-box]', sec);
    if (box) {
      var img = $('img', box);
      sec.addEventListener('click', function (e) {
        var z = e.target.closest('[data-cv-zoom]');
        if (z) { img.src = z.getAttribute('data-cv-zoom'); box.hidden = false; }
      });
      box.addEventListener('click', function (e) { if (e.target !== img) box.hidden = true; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') box.hidden = true; });
    }
  }

  /* ---------- sticky bar ---------- */
  function initSticky(bar) {
    if (!once(bar, 'st')) return;
    var atc = $('[data-cv-atc]');
    var pack = $('[data-cv-st-pack]', bar), price = $('[data-cv-st-price]', bar), was = $('[data-cv-st-was]', bar);
    document.addEventListener('cv:pack', function (e) {
      var d = e.detail || {};
      if (pack) pack.textContent = d.title || '';
      if (price && d.price) price.textContent = d.price;
      if (was) was.textContent = d.was || '';
    });
    var on = $('[data-cv-pack].is-on');
    if (on) {
      if (pack) pack.textContent = on.getAttribute('data-title');
      if (price) price.textContent = on.getAttribute('data-price');
      if (was) was.textContent = on.getAttribute('data-was');
    }
    function check() {
      if (!atc) { bar.classList.toggle('is-show', window.scrollY > 600); return; }
      var r = atc.getBoundingClientRect();
      bar.classList.toggle('is-show', r.bottom < 0);
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
    $('[data-cv-st-btn]', bar).addEventListener('click', function () {
      var form = atc && atc.form;
      if (bar.getAttribute('data-action') === 'add' && form && !atc.disabled) {
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      } else {
        goOffer();
      }
    });
  }

  function goOffer() {
    var t = $('.cv-offer') || $('#cv-top');
    if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
  }

  function init() {
    $$('[data-cv-gal]').forEach(initGallery);
    $$('[data-cv-product]').forEach(initProduct);
    $$('[data-cv-cd]').forEach(initCountdown);
    $$('[data-cv-quotes]').forEach(initQuotes);
    var rv = $$('[data-cv-reviews]');
    rv.forEach(initReviews);
    if (!rv.length) setRating(0, 0);
    $$('[data-cv-sticky]').forEach(initSticky);
    $$('[data-cv-go]').forEach(function (a) {
      if (!once(a, 'go')) return;
      a.addEventListener('click', function (e) { e.preventDefault(); goOffer(); });
    });
    $$('.cv video[autoplay]').forEach(function (v) {
      v.muted = true;
      var p = v.play && v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
